import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { gapi, errMsg, AZIONI_LABEL } from "../api";
import { useGAuth } from "../GAuth";
import { PageHeader, Panel, Btn } from "../components/ui";

const RUOLI_EDIT = [["agente", "Agente / Collaboratore"], ["segreteria", "Segreteria"]];

export default function Permessi() {
  const { session, refresh } = useGAuth();
  const isOwner = session.user.ruolo === "titolare";
  const [matrix, setMatrix] = useState(null);
  const [ruolo, setRuolo] = useState("agente");
  const [saving, setSaving] = useState(false);

  useEffect(() => { gapi.get("/permissions").then((r) => setMatrix(r.data.matrix)); }, []);

  if (!matrix) return <p className="text-sm text-anthracite/50">Caricamento…</p>;
  const cur = matrix[ruolo];

  const toggle = (res, az) => {
    const acts = new Set(cur.permessi[res] || []);
    acts.has(az) ? acts.delete(az) : acts.add(az);
    setMatrix({ ...matrix, [ruolo]: { ...cur, permessi: { ...cur.permessi, [res]: [...acts] } } });
  };
  const setAmbito = (res, v) => setMatrix({ ...matrix, [ruolo]: { ...cur, ambito: { ...cur.ambito, [res]: v } } });

  const save = async () => {
    setSaving(true);
    try { const { data } = await gapi.put("/permissions", { matrix }); setMatrix(data.matrix); await refresh(); toast.success("Permessi salvati"); }
    catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <div data-testid="g-perms-page">
      <PageHeader eyebrow="Amministrazione" title="Ruoli e permessi"
        desc="I permessi sono verificati dal server su ogni richiesta e su ogni file: nascondere un pulsante non basta ad aggirarli. Il titolare ha sempre accesso completo."
        actions={isOwner && <Btn onClick={save} disabled={saving} data-testid="g-perms-save">{saving ? "Salvataggio…" : "Salva permessi"}</Btn>} />
      <div className="flex gap-2 mb-5">
        {RUOLI_EDIT.map(([k, l]) => (
          <button key={k} onClick={() => setRuolo(k)} className={`rounded-full px-4 h-10 text-sm font-semibold transition-colors ${ruolo === k ? "bg-anthracite text-white" : "bg-white border border-border-subtle"}`} data-testid={`g-perms-tab-${k}`}>{l}</button>
        ))}
        <span className="inline-flex items-center gap-2 rounded-full px-4 h-10 text-sm bg-white border border-border-subtle text-anthracite/45"><Lock className="h-4 w-4" /> Titolare: tutto</span>
      </div>
      <Panel>
        <div className="overflow-x-auto -mx-5 sm:mx-0">
          <table className="w-full text-sm min-w-[860px]">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-anthracite/45">
              <th className="py-2 px-5 sm:px-2">Area</th>{session.azioni.map((a) => <th key={a} className="px-2 text-center">{AZIONI_LABEL[a]}</th>)}<th className="px-2">Ambito</th>
            </tr></thead>
            <tbody className="divide-y divide-border-subtle">
              {session.risorse.map(([res, label]) => (
                <tr key={res} data-testid={`g-perm-row-${res}`}>
                  <td className="py-2.5 px-5 sm:px-2 font-medium">{label}</td>
                  {session.azioni.map((a) => (
                    <td key={a} className="px-2 text-center">
                      <input type="checkbox" className="h-4 w-4 accent-[#0F5C4A]" disabled={!isOwner} checked={(cur.permessi[res] || []).includes(a)} onChange={() => toggle(res, a)} data-testid={`g-perm-${ruolo}-${res}-${a}`} />
                    </td>
                  ))}
                  <td className="px-2">
                    <select disabled={!isOwner} value={cur.ambito[res] || "assegnati"} onChange={(e) => setAmbito(res, e.target.value)} className="h-8 rounded-lg border border-border-subtle px-2 text-xs" data-testid={`g-perm-ambito-${ruolo}-${res}`}>
                      <option value="assegnati">Solo assegnati/condivisi</option><option value="tutti">Tutti</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  );
}
